/**
 * The SEO payload shapes used by the admin "SEO Setup" screen. They mirror the backend DTOs in
 * `com.reverse.job.portal.Seo.DTO`.
 */

export interface SeoSiteSettings {
  baseUrl: string;
  siteName: string;
  defaultTitle: string;
  defaultDescription: string;
  ogImage: string;
  twitterHandle: string;
  organizationLegalName: string;
  organizationLogo: string;
  organizationDescription: string;
  locale: string;
  googleSiteVerification: string;
  indexingEnabled: boolean;
  sitemapEnabled: boolean;
  extraRobotsRules: string;
}

export interface SeoPageConfig {
  key: string;
  path: string;
  label: string;
  title: string;
  description: string;
  canonicalUrl: string;
  ogImage: string;
  ogType: string;
  indexable: boolean;
  sitemapInclude: boolean;
  priority: number;
  changeFreq: string;
  structuredDataType: string;
  structuredDataJson: string;
  lastModified: string;
  customized: boolean;
}

export interface SeoPublicConfig {
  site: SeoSiteSettings;
  pages: SeoPageConfig[];
}

export interface SeoPageConfigRequest {
  pageKey?: string;
  path: string;
  label?: string;
  title?: string;
  description?: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: string;
  indexable?: boolean;
  sitemapInclude?: boolean;
  priority?: number;
  changeFreq?: string;
  structuredDataType?: string;
  structuredDataJson?: string;
  lastModified?: string;
}

export const CHANGE_FREQUENCIES = [
  "always",
  "hourly",
  "daily",
  "weekly",
  "monthly",
  "yearly",
  "never",
];

export const STRUCTURED_DATA_TYPES = ["NONE", "WEB_PAGE", "FAQ_PAGE", "ARTICLE"];

export const OG_TYPES = ["website", "article", "profile", "product"];
